import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DataService } from '../../common/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AppTokenHandler } from '../../common/app-token-handler';
import { saveAs } from 'file-saver';
import { CommonService } from 'src/app/services/common.service';
@Component({
    selector: 'app-resueme-cart',
    templateUrl: './resueme-cart.component.html',
    styleUrls: ['./resueme-cart.component.css']
})
export class ResuemeCartComponent implements OnInit {
    constructor(private gservice: DataService, private router: Router,
        private appToken: AppTokenHandler, private cp: DatePipe, private _commonService: CommonService) { }
    PageHeading: string = "Resume Cart";
    first: number = 0;
    loading: boolean = false;
    cols: any[];
    ResumePerPageSelected: number = 1;
    RequestDetailsList: Array<any> = [];
    SelectedRequestDetailsList: Array<any> = [];
    CartObject: Array<any> = [];
    ngOnInit() {
        if (sessionStorage.getItem('ResumeCart') != null) {
            this.CartObject = JSON.parse(sessionStorage.getItem('ResumeCart'));
            if (this.CartObject.length > 0) {
                this.RequestDetailsList = this.CartObject.map(x => x.ResumeObject);
            };
        }
        this.cols = [
            { field: 'ResumeId', header: 'Resume ID' },
            { field: 'EmployeeName', header: 'Employee Name' },
            { field: 'EmpTitle', header: 'Designation' },
            { field: 'YearOfExperience', header: 'Years of Experience' },
            { field: 'SMU', header: 'Competency' },
            { field: 'EngTitle', header: 'Eng Type' },
            { field: 'Sector', header: 'Eng Sector' },
            { field: 'SubSector', header: 'Eng Sub Sector' },
            { field: 'GeographicType', header: 'Geographic Type' }
        ];
        console.log(this.RequestDetailsList);
    }
    paginate(event) {
        this.first = event.first;
    }
    GenerateResume() {
        let _isError: boolean = false;
        //if (this.SelectedRequestDetailsList.length < 1 && this.ResumePerPageSelected == 1) {
        //    _isError = true;
        //    alert("Please select atleast 1 record.");
        //}
        //else if (this.SelectedRequestDetailsList.length < 2 && this.ResumePerPageSelected == 2) {
        //    _isError = true;
        //    alert("Please select atleast 2 records.");
        //}
        //else if (this.SelectedRequestDetailsList.length < 3 && this.ResumePerPageSelected == 3) {
        //    _isError = true;
        //    alert("Please select atleast 3 records.");
        //}
        //else if (this.SelectedRequestDetailsList.length > 10 && (this.ResumePerPageSelected == 1 || this.ResumePerPageSelected == 2)) {
        //    _isError = true;
        //    alert("Only 10 resume can be generated.");
        //}
        //else if (this.SelectedRequestDetailsList.length > 12 && this.ResumePerPageSelected == 3) {
        //    _isError = true;
        //    alert("Only 12 resume can be generated.");
        //}
        //else if (this.SelectedRequestDetailsList.length > 0 && (this.ResumePerPageSelected == 2 || this.ResumePerPageSelected == 3)) {
        //    if (this.SelectedRequestDetailsList.length % this.ResumePerPageSelected > 0) {
        //        _isError = true;
        //        alert("Please select records in multiple of " + this.ResumePerPageSelected);
        //    }
        //}
        if (this.SelectedRequestDetailsList.length < 1) {
            _isError = true;
            alert("Please select atleast 1 record.");
        }
        else if (this.SelectedRequestDetailsList.length > 12) {
            _isError = true;
            alert("Only 12 resume can be generated.");
        }
        if (!_isError && this.SelectedRequestDetailsList.length > 0) {
            let _url: string = "GeneratePPT";
            if (this.ResumePerPageSelected == 2) {
                _url = "GeneratePPT2";
            }
            else if (this.ResumePerPageSelected == 3) {
                _url = "GeneratePPT3";
            }

            let filteredCartObject = [];

            for (var arr in this.SelectedRequestDetailsList) {
                for (var filter in this.CartObject) {
                    if (this.SelectedRequestDetailsList[arr].ResumeId == this.CartObject[filter].ResumeId) {
                        filteredCartObject.push(this.CartObject[filter]);
                    }
                }
            }

            console.log(filteredCartObject);

            this.gservice.DownloadFileWithPost(_url, filteredCartObject).subscribe((data: any) => {
                debugger;
                let _UserDetails: any;
                _UserDetails = this.appToken.getLoginUserInfo();
                if (_UserDetails && _UserDetails.DigiPitchID > 0) {
                    alert("Resume(s) has been generated. Kindly close this tab.");
                }
                else {
                    const blob = new Blob([data], { type: 'application/octet-stream' });
                    saveAs(blob, 'myResume.pptx');
                }
            }, error => {
                debugger;
                console.log('error');
            });
        }
    }
    ResetCart() {
        sessionStorage.removeItem('ResumeCart');
        this.RequestDetailsList = [];
        this.SelectedRequestDetailsList = [];
    }
    onCickRequestNumber(RequestNumber) {
        this.StoreDataInCache();
        this.router.navigate(['/home/resume'], { queryParams: { param1: this._commonService.EncryptData(RequestNumber) } });
    }
    RedirectToSearchPage() {
        this.StoreDataInCache();
        this.router.navigate(['/home/SearchResume']);
    }
    StoreDataInCache() {
        if (sessionStorage.getItem('callbackObject') != null) {
            this.loading = true;
            let objForSearch: any = null;
            objForSearch = JSON.parse(sessionStorage.getItem('callbackObject'));
            objForSearch.callbackUrl = '/home/ResumeCart';
            sessionStorage.setItem('callbackObject', JSON.stringify(objForSearch));
        }
        else {
            let objForSearch: any = { callbackUrl: 'home/ResumeCart', objSearchParams: null };
            sessionStorage.setItem('callbackObject', JSON.stringify(objForSearch));
        }
    }
}
